import { composeIO } from 'react-compose-io'
import { itemTransformacaoIO } from './ItemTransformacao.IO'
import { ItemTransformacaoView } from './ItemTransformacao.View'

export const ItemTransformacao = composeIO(ItemTransformacaoView, itemTransformacaoIO)
